import {log, logError} from '../webUtils'

const languages = (state = [], action) => {
  switch (action.type) {
    case 'ADD_LANGUAGE':
      var id= Math.max(0, ...state.map(f => f.id)) + 1;
      return [
        ...state,
        {
          id: id,
          name: action.name,
          code: action.code,
          activityId: action.activityId,
        }
      ]
    case 'CHANGE_LANGUAGE_NAME':
      return state.map(language => {
        if(language.id === action.id) {
          return {...language,
            name: action.name,
          };
        }
        return language;
      })
    case 'CHANGE_LANGUAGE_CODE':
      return state.map(language => {
        if(language.id === action.id) {
          return {...language,
            code: action.code,
          };
        }
        return language;
      })
    case 'DELETE_LANGUAGE':
      return state.filter(({ id }) => id !== action.id);
    case 'PUSH_ACTIVITY_CONTENT':
      if(typeof action.data.languages == 'undefined') {
        log('Undefined data.enigmas from server.')
        return state;
      }
      else
        return action.data.languages;
    case 'SET_STATE_FROM_DATABASE':
      if(typeof action.state.languages === 'undefined') {
        log ('Undefined "state.languages" from server.')
        return state;
      }
      else
        return action.state.languages;
    default:
      return state
  }
}

export default languages
